<script lang="ts">
export default {
  name: 'SnapToToggle',
};
</script>

<script setup lang="ts">
import { StoreMutationType } from '@/types/StoreMutationType';
import { computed, inject } from 'vue';
import { Store } from 'vuex';
import { AppState } from '@/store';
import snap_to_enabled from '@/assets/images/snap_to_enabled.svg';
import snap_to_disabled from '@/assets/images/snap_to_disabled.svg';

// ---------------
// reactive data
// ---------------
const store = inject<Store<AppState>>('store');

// ----------
// computed
// ----------
const snapToEnabled = computed<boolean | undefined>(() => {
  return store?.state.towerCanvasState.snapToModeEnabled;
});

// ----------
// handlers
// ----------
function handleToggleSnapTo(e: MouseEvent): void {
  e.stopPropagation();
  store?.commit(StoreMutationType.SET_SNAP_TO_MODE, !store?.state.towerCanvasState.snapToModeEnabled);
}
</script>

<template>
  <div class="tw:self-end tw:py-2">
    <label title="Toggle Snap-To">
      <input
        type="checkbox"
        name="snap-to-toggle"
        aria-label="Snap-To Toggle"
        class="tw:pointer-events-none tw:box-border tw:hidden"
        @click="handleToggleSnapTo"
      />
      <img
        :src="snapToEnabled ? snap_to_enabled : snap_to_disabled"
        :alt="snapToEnabled ? 'Snap to enabled' : 'Snap to disabled'"
        :class="{ selected: snapToEnabled }"
        class="button toggle-button tw:border-box tw:pointer-events-auto tw:flex tw:h-10 tw:w-10 tw:cursor-pointer tw:items-center tw:rounded-lg tw:shadow-lg"
      />
    </label>
  </div>
</template>

<style scoped>
.toggle-button {
  background-color: var(--tower-v2-alt-bg-color);
  border: 1px solid var(--tower-v2-border-color);
}

.selected {
  background-color: var(--tower-v2-tool-selected-color);
}

.button:hover {
  background-color: var(--tower-v2-hover-color);
}
</style>
